export default "__VITE_ASSET__6f86c809__"